import React from 'react'
import styled from 'styled-components';
import { Button } from '../styles/Button';
import { NavLink } from 'react-router-dom';

const Error = () => {
  return (
    <Wrapper className='section'>

    <img src='./photos/error.png' alt= 'error'/>
    <NavLink to ="/">
    <Button className='btn'> Go Back</Button></NavLink>

    </Wrapper>
  )
}

const Wrapper = styled.section`
padding: 9rem 0;
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;

.btn{
    margin-top:3rem;
    font-size: 1.9rem;
}
`;

export default Error